var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',{attrs:{"id":"footer"}},[_c('b',[_vm._v("© "+_vm._s(_vm.actualYear)+" Air Europa Líneas Aéreas S.A.U.")]),_vm._v(" "),_c('br'),_vm._v(" Ctra. Arenal - Llucmajor, km.21,5 - 07620 Llucmajor · Baleares · España ")])
}
var staticRenderFns = []

export { render, staticRenderFns }